import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class CarRentalPackageService {
  static getcarrentalPackageList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getcarrentalPackage}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getcarrentalPackage}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addcarrentalPackage(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addcarrentalPackage}`;
    return axiosInstance
        .post(api,item)
        
}
static editcarrentalPackage(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editcarrentalPackage}`;
    return axiosInstance
        .put(api,item)
        
}
static deletecarrentalPackage(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletecarrentalPackage}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletecarrentalPackage}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default CarRentalPackageService;